import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { QUERY_KEYS } from '@/api/constants'
import { apiDuplicateSession } from '@/api/session'
import { useNotifications } from '@/hooks/useNotifications'

export const useDuplicateSession = () => {
  const queryClient = useQueryClient()
  const { notifySuccess, notifyError } = useNotifications()
  const t = useTranslations('session')

  return useMutation({
    mutationFn: (id: string) => apiDuplicateSession(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SESSIONS],
      })
      notifySuccess(t('session_duplicated_successfully'))
    },
    onError: () => notifyError(t('session_duplication_failed')),
  })
}
